export default __webpack_public_path__ + "static/media/grafema_coimbra-2027-contest_21.8743dcb9.jpg";